const is = require('../plugins/helper/is')
const { listen } = require('../plugins/event/listen')

if (is.node('#enviarWhatsappAVendedor')) {
  listen('#enviarWhatsappAVendedor', 'click', function(e) {
    const trigger = e.delegateTarget || e.currentTarget

    const phone = '50766794527'
    const text = is.getAttributeValue(trigger, 'mensaje')
    const parametros = is.createTheParametersOfTheUrl({phone, text})

    window.open(`https://api.whatsapp.com/send${parametros}`, '_blank')
  })
}

if (is.node('input[name=sector_trabajo]')) {
  listen('input[name=sector_trabajo]', 'click', (e) => {
    const trigger = e.delegateTarget || e.currentTarget
    const radios = document.getElementsByName('estatus_laboral')

    if (radios) {
      if (trigger.value === 'Jubilado' || trigger.value === 'Independiente') {
        for (const radio of radios) {
          radio.disabled = true
          radio.checked = false
        }
      }
      else {
        for (const radio of radios) {
          radio.disabled = false
        }
      }
    }
  })
}
